<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="primary white--text title">
                    Compressor Health
                </v-card-title>
                <v-card-text>
                    <date-range-selector v-model="range"></date-range-selector>
                    <v-switch
                            v-model="onOnly"
                            label="View Points when Chiller is On"
                    ></v-switch>
                </v-card-text>
                <v-card-text>
                    <refrigerant-temp-pressure-plot
                            :date-range="range"
                            variable-x="Oil_Temp"
                            variable-y="Oil_Temp"
                            :on-only="onOnly"
                            type="histogram"
                    ></refrigerant-temp-pressure-plot>

                    <refrigerant-temp-pressure-plot
                            :date-range="range"
                            variable-x="Comp_Power"
                            variable-y="Comp_Power"
                            :on-only="onOnly"
                            type="histogram"
                    ></refrigerant-temp-pressure-plot>

                    <refrigerant-temp-pressure-plot
                            :date-range="range"
                            variable-x="Oil_Temp"
                            variable-y="Comp_Power"
                            :on-only="onOnly"
                            type="scattergl"
                    ></refrigerant-temp-pressure-plot>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
  import RefrigerantTempPressurePlot from '../../components/faults/RefrigerantTempPressurePlot'
  import DateRangeSelector from '../../components/DateRangeSelector'
  export default {
    name: 'CompressorHealth',
    components: { DateRangeSelector, RefrigerantTempPressurePlot },
    data () {
      return {
        range: null,
        onOnly: true
      }
    }
  }
</script>

<style scoped>

</style>
